var map = {
	"./404.svg": "sEM+",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./documentation.svg": "zUKd",
	"./download.svg": "+H2/",
	"./edit.svg": "ql+d",
	"./education.svg": "wyC6",
	"./email.svg": "+4G4",
	"./excel.svg": "OLl3",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./icon-account.svg": "HXG9",
	"./icon-agent.svg": "wmu9",
	"./icon-commission.svg": "Pelq",
	"./icon-money.svg": "PwxV",
	"./icon-pay.svg": "1pm2",
	"./icon-peoples.svg": "s4Z7",
	"./icon-system.svg": "9Rh0",
	"./icon-xtx.svg": "h5LY",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./menu_account.svg": "GqV/",
	"./menu_agent.svg": "ahhk",
	"./menu_money.svg": "DUaE",
	"./menu_operat.svg": "FMJ6",
	"./menu_pay.svg": "5xH9",
	"./menu_system.svg": "zlQt",
	"./merchant.svg": "8OX1",
	"./message.svg": "G2zY",
	"./people.svg": "GPe0",
	"./tree-table.svg": "myHh",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./warningDang.svg": "e3LW",
	"./wechat.svg": "pYJ+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 46